import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import {
  Container,
  Form,
  Header,
  Segment,
  Message,
  Radio,
} from 'semantic-ui-react';
import { fetchCustomers, selectCustomer } from '../actions/customers';
import { CustomerSelector } from './CustomerSelector';
import { getCustomers } from '../reducers/customers';
import { getCustomerId, getErrors, getIsExistingSite } from '../reducers/form';
import SiteSelector from './SiteSelector';
import { updateIsExistingSite } from '../actions/form';

const mapStateToProps = (state, ownProps) => ({
  customers: getCustomers(state),
  customerId: getCustomerId(state),
  displaySite: getIsExistingSite(state),
  errors: getErrors(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchCustomers: () => dispatch(fetchCustomers()),
  selectCustomer: customerId => dispatch(selectCustomer(customerId)),
  updateFormIsExistingSite: value => dispatch(updateIsExistingSite(value)),
});

export class Page extends React.Component {
  constructor(props) {
    super(props);
    this.handleDisplayConfirmation = this.handleDisplayConfirmation.bind(this);
    this.state = { displayConfirmation: false };
  }

  componentWillMount() {
    this.props.fetchCustomers();
  }

  handleDisplayConfirmation() {
    this.setState({ displayConfirmation: true });
  }

  render() {
    const {
      currentCustomerId,
      customers,
      selectCustomer,
      customerId,
      displaySite,
      errors,
    } = this.props;

    const displayConfirmation = this.state.displayConfirmation;

    const customerChoices = customers.filter(c => c.id !== currentCustomerId);

    const handleDisplaySite = (e, { value }) => {
      this.props.updateFormIsExistingSite('true' === value);
    };

    const buttonClassName = display => {
      if (display) {
        return 'ui primary button';
      } else {
        return 'ui primary button confirm-hidden';
      }
    };

    return (
      <Form>
        <Segment>
          {errors.includes('checkFailed') && (
            <Form.Field>
              <Message size="tiny" color="red">
                Certaines interventions du chantiers ne sont pas validées.
              </Message>
            </Form.Field>
          )}
          <Header as="h3">Transférer ce chantier chez un autre client</Header>
          <CustomerSelector
            customerId={customerId && customerId.toString()}
            onChange={selectCustomer}
            customerChoice={customerChoices}
            errors={errors}
          />
          {customerId && (
            <Form.Field>
              <Form.Field required>
                <label>
                  2- Souhaitez-vous rattacher ce chantier à un site existant du
                  nouveau client ?
                </label>
              </Form.Field>
              <Form.Field>
                <Radio
                  label="Oui, je choisis un site existant du nouveau client"
                  name="radioGroup"
                  value="true"
                  checked={displaySite === true}
                  onChange={handleDisplaySite}
                />
              </Form.Field>
              <Form.Field>
                <Radio
                  label="Non, je souhaite copier le site actuel du chantier vers le nouveau client"
                  name="radioGroup"
                  value="false"
                  checked={displaySite === false}
                  onChange={handleDisplaySite}
                />
              </Form.Field>
            </Form.Field>
          )}
          {customerId &&
            displaySite && <SiteSelector customerId={customerId} />}
          {displayConfirmation && (
            <Form.Field>
              <Message size="tiny" color="orange">
                Êtes-vous sûr de vouloir transférer le chantier au nouveau
                client?
              </Message>
            </Form.Field>
          )}
          <Container textAlign="right">
            <div className="actions">
              <div
                className={buttonClassName(!displayConfirmation)}
                id="bt-validate"
                onClick={this.handleDisplayConfirmation}
              >
                Valider
              </div>
              <div
                className={buttonClassName(displayConfirmation)}
                id="bt-confirm"
              >
                Confirmer
              </div>
              <div id="bt-cancel" className="ui cancel button">
                Annuler
              </div>
            </div>
          </Container>
        </Segment>
      </Form>
    );
  }
}

Page.propTypes = {
  currentCustomerId: PropTypes.number.isRequired,
  customers: PropTypes.array.isRequired,
  customerId: PropTypes.number,
  fetchCustomers: PropTypes.func.isRequired,
  selectCustomer: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/components/CaseTransferModal.js